/**
 * Garázskapu színek / felület swatchek per prelis+motiv (PDF cenník stílus).
 * Kód és színnév; colorHex opcionális (placeholder háttér), később imageUrl is lehet.
 */

/** Nincs ismert RAL/szín — semleges placeholder (nem UI téma-token). */
export const DEFAULT_SWATCH_PLACEHOLDER_HEX = "#e5e5e5";

export interface PriceSwatchItem {
  code: string;
  name: string;
  colorHex?: string;
  imageUrl?: string;
}

type PrelisKey = "woodgrain" | "decocolor" | "planar" | "slategrain" | "micrograin" | "metallic";
type MotivKey = "m" | "l";

const SWATCHES: Partial<Record<PrelisKey, Partial<Record<MotivKey, PriceSwatchItem[]>>>> = {
  planar: {
    m: [
      { code: "CH 9016", name: "Biela", colorHex: "#f5f5f0" },
      { code: "CH 905", name: "Čierna", colorHex: "#2d2d2d" },
      { code: "CH 9006", name: "Biely hliník", colorHex: "#c8c8c8" },
      { code: "CH 9007", name: "Sivý hliník", colorHex: "#8c8c8c" },
      { code: "CH 7016", name: "Antracitová sivá", colorHex: "#4a4a4a" },
      { code: "CH 8028", name: "Terakotová hnedá", colorHex: "#8b4513" },
      { code: "CH 703", name: "Antracit metallic", colorHex: "#3d3d3d" },
    ],
  },
  woodgrain: {
    m: [
      { code: "—", name: "Woodgrain M", colorHex: "#d4c4a8" },
    ],
    l: [
      { code: "—", name: "Woodgrain L", colorHex: "#c4b898" },
    ],
  },
  decocolor: {
    m: [
      { code: "—", name: "Decocolor M", colorHex: "#e8e0d8" },
    ],
  },
  slategrain: {
    m: [
      { code: "—", name: "Slategrain M", colorHex: "#a0a0a0" },
    ],
  },
  micrograin: {
    m: [
      { code: "—", name: "Micrograin M", colorHex: "#b0b0b0" },
    ],
  },
  metallic: {
    m: [
      { code: "—", name: "Metallic M", colorHex: "#909090" },
    ],
  },
};

export function getSwatchesForSection(prelis: string, motiv: string): PriceSwatchItem[] {
  const p = prelis.toLowerCase() as PrelisKey;
  const m = motiv.toLowerCase() as MotivKey;
  const list = SWATCHES[p]?.[m];
  if (list?.length) return list;
  return [{ code: "—", name: `${prelis} ${motiv}`, colorHex: DEFAULT_SWATCH_PLACEHOLDER_HEX }];
}
